import { TZ_CITIES_TO_COUNTRIES } from './tz-cities-to-countries.const';

export function detectCountryFromTimezone(): string {
  if (typeof Intl === 'undefined') {
    return '';
  }

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const parts = timeZone.split('/');
  const city = parts[parts.length - 1];

  return TZ_CITIES_TO_COUNTRIES[city] ?? '';
}
